module.exports = {"yytx06":{"daobanList":[{"title":"1:城镇职工基本养老保险关系转移接续申请","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、企业职工基本养老保险重复缴费退款申请表","state":"非必要"},{"name":"2、有效身份证件原件","state":"必要"},{"name":"3、调动材料","state":"必要"},{"name":"4、个人委托书","state":"必要"},{"name":"5、人民法院、审计部门、实施劳动监察的行政部门或劳动争议仲裁委员会出具的法律文书","state":"非必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx06.json
// module id = 1305
// module chunks = 0